import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-market",
  "use": "icon-market-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" id=\"icon-market\"><path d=\"M810.656 853.344H640v-170.656c0-25.6-17.056-42.656-42.656-42.656h-170.656c-25.6 0-42.656 17.056-42.656 42.656v170.656H213.376V640H128.032v256c0 25.6 17.056 42.656 42.656 42.656h682.656c25.6 0 42.656-17.056 42.656-42.656v-256h-85.344v213.344z m-341.312 0v-128h85.344v128h-85.344zM977.056 499.2l-85.344-256c-4.256-17.056-21.344-29.856-38.4-29.856H170.656c-17.056 0-34.144 12.8-38.4 29.856l-85.344 256c-8.544 12.8-4.256 25.6 4.256 38.4s21.344 17.056 34.144 17.056h853.344c12.8 0 25.6-8.544 34.144-17.056 8.544-12.8 12.8-25.6 4.256-38.4z m-422.4-200.544h93.856l29.856 170.656h-123.744V298.656z m-85.312 170.688h-119.456l29.856-170.656h89.6v170.656z m-268.8-170.688h89.6l-29.856 170.656h-115.2l55.456-170.656z m558.912 170.688L729.6 298.688h89.6l55.456 170.656h-115.2zM213.344 85.344h597.344v85.344H213.344V85.344z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/market.svg
// module id = 0RbO
// module chunks = 77